import React from "react";
import { Row, Col } from "antd";
import "../../assets/css/patrocinadores.css";


import patro1 from "../../assets/images/2025/organizadores/Madison.png";
import patro2 from "../../assets/images/2025/organizadores/Jefferson.png";
import patro3 from "../../assets/images/2025/organizadores/Wythe.png";
import patro4 from "../../assets/images/2025/organizadores/MejiaSucesores.png";
import patro5 from "../../assets/images/2025/organizadores/Transpiramide.png";


let logos = [
  { tipo: 1, img_src: patro1 },
  { tipo: 1, img_src: patro2 },
  { tipo: 1, img_src: patro3 },
  { tipo: 1, img_src: patro4 },
  { tipo: 1, img_src: patro5 },
];

const Sponsors = () => {
  const items = logos
    .filter((i) => i.tipo === 1)
    .map((logo, index) => (
      <Col xs={12} md={7} key={index} className="patro-logo-col">
        <img src={logo.img_src} alt="" className="patro-logo" />
      </Col>
    ));

  return (
    <>
      <Row justify="center" className="patro-container">
        <Col xs={24}>
          <p className="titulo_patrocinadores">Organizadores</p>
        </Col>

        <Col xs={22} md={20}>
          <Row justify="center" gutter={[40, 40]}>
            {items}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Sponsors;
